export default {"src":"/_next/static/media/shopping_cart_icon_dart.9cd462b5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};